import { useMutation } from '@tanstack/react-query'
import { NotificationService } from '@/modules/utilities/notification/services/NotificationService.ts'
import useInvalidateQuery from '@/core/hooks/useInvalidateQuery.ts'

const useNotificationLogic = () => {
  const { invalidate } = useInvalidateQuery()
  const { mutate: handlerMarkAllAsRead, isPending } = useMutation({
    mutationKey: ['markAsReadAll'],
    mutationFn: () => NotificationService.readAll(),
    onSuccess: () => {
      void invalidate({ queryKey: ['listNotifications'] })
    }
  })

  return {
    handlerMarkAllAsRead,
    isPending
  }
}

export default useNotificationLogic
